import React, { useState, useEffect, useRef } from "react";
import { FaBars, FaSun, FaMoon } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import "./Header.css";
import logo from "../Assets/logo.png";
import userIcon from "../Assets/contact.png";
import LoginModal from "../Login/LoginModal";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(true);
  const [user, setUser] = useState(null);
  // const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const navigate = useNavigate();
  const menuRef = useRef();

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("user"));
    if (storedUser) setUser(storedUser);
  }, []);

  const toggleTheme = () => {
    setIsDarkMode((prev) => !prev);
  };

  const handleLogout = () => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");
    setUser(null);
    window.location.reload();
  };

  const handleClickOutside = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setIsMenuOpen(false);
    }
  };

  useEffect(() => {
    if (isMenuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isMenuOpen]);

  const handleNavClick = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <>
      <motion.header
        className={`navveer-header ${isDarkMode ? "light" : "dark"}`}
        initial={{ y: -70 }}
        animate={{ y: 0 }}
        transition={{ type: "spring", stiffness: 80 }}
      >
        <div className="navveer-left">
          <motion.div
            className="navveer-logo"
            whileHover={{ scale: 1.05 }}
            transition={{ type: "spring", stiffness: 300 }}
          >
            <img src={logo} alt="Navveer Logo" />
            <span>Navveer Foundation</span>
          </motion.div>
        </div>

        <nav className="navveer-nav-links-desktop">
          <Link to="/">Home</Link>
          <Link to="/programs">Programs</Link>
          <Link to="/research">Research</Link>

          <div className="navveer-dropdown">
            <span className="navveer-dropdown-trigger">Digital Library ▾</span>
            <div className="navveer-dropdown-content">
              <Link to="/library">E-Books</Link>
              <Link to="/library/ejournals">E-Journals</Link>
              <Link to="/library/emagazines">E-Magazines</Link>
              
            </div>
          </div>

         <Link to="/NavveerBooks">Navveer Publisher</Link>

          <Link to="/counselling">Counselling</Link>
          <Link to="/blog">Blogs</Link>
           <Link to="/donate">Contribute</Link>
          <Link to="/contact">Contact</Link>
        </nav>

        <div className="navveer-right">
          {/* <input
            type="text"
            placeholder="Search..."
            className="navveer-search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          /> */}
         
          <button className="navveer-theme-toggle" onClick={toggleTheme}>
            {isDarkMode ? <FaSun /> : <FaMoon />}
          </button>

          {user ? (
            <div className="navveer-user">
              <span>Welcome, {user.name}</span>
              <button onClick={handleLogout}>Logout</button>
            </div>
          ) : (
            <img
              src={userIcon}
              alt="Login"
              className="navveer-icon"
              onClick={() => setShowModal(true)}
            />
          )}

          <FaBars
            className="navveer-hamburger"
            onClick={() => setIsMenuOpen(true)}
          />
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {isMenuOpen && (
            <motion.div
              className="navveer-menu-popup"
              ref={menuRef}
              initial={{ opacity: 0, scale: 0.95, y: -10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: -10 }}
              transition={{ duration: 0.25 }}
            >
              <nav className="navveer-nav-links-mobile">
                <span onClick={() => handleNavClick("/")}>Home</span>
                <span onClick={() => handleNavClick("/programs")}>Programs</span>
                <span onClick={() => handleNavClick("/research")}>Research</span>

                <div className="navveer-dropdown">
                  <span className="navveer-dropdown-trigger">Digital Library ▾</span>
                  <div className="navveer-dropdown-content">
                    <span onClick={() => handleNavClick("/library")}>E-Books</span>
                    <span onClick={() => handleNavClick("/library/ejournals")}>E-Journals</span>
                    <span onClick={() => handleNavClick("/library/emagazines")}>E-Magazines</span>
                  </div>
                </div>

                <span onClick={() => handleNavClick("/counselling")}>Counselling</span>
                <span onClick={() => handleNavClick("/blog")}>Blogs</span>
                <span onClick={() => handleNavClick("/donate")}>Contribute</span>
                <span onClick={() => handleNavClick("/contact")}>Contact</span>
              </nav>
            </motion.div>
          )}
        </AnimatePresence>

        
      </motion.header>
      <motion.header></motion.header>

      {showModal && <LoginModal closeModal={() => setShowModal(false)} />}
        


    </>
  );
};

export default Header;
